// # Resume section component for profile
import React from 'react';
import './prfl_resumee.css';

const ProfileResume = ({ isDarkMode }) => {
  return (
    <div className={`prfl_resumee_container ${isDarkMode ? 'prfl_dark-mode' : ''}`}>
      <div className="prfl_resumee_coming-soon">
        <h3>Resume Feature Coming Soon</h3>
        <p>Create and showcase your medical professional resume.</p>
      </div>
    </div>
  );
};

export default ProfileResume;
